import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { CATEGORIES } from "@/lib/categories";

// Category chips shown across Home, Collection and Search pages.
// Renders the full V1.0 category catalogue as a horizontally-scrollable rail,
// followed by the two evergreen shortcut chips (New Arrivals, Sale).
const CHIPS = [
  ...CATEGORIES.map((c) => ({ key: c.key, label: c.label, to: `/category/${c.key}` })),
  { key: "new", label: "New Arrivals", to: "/collection/new" },
  { key: "sale", label: "Sale", to: "/collection/sale", accent: "gold" },
];

const CategoryChips = () => {
  return (
    <div className="scrollbar-hide -mx-4 flex gap-2 overflow-x-auto px-4 pb-1 sm:mx-0 sm:px-0" data-testid="category-chips">
      {CHIPS.map((c) => (
        <NavLink
          key={c.key}
          to={c.to}
          data-testid={`chip-${c.key}`}
          className={({ isActive }) =>
            cn(
              "shrink-0 whitespace-nowrap border px-4 py-2 text-[11px] font-semibold uppercase tracking-widest transition-all",
              isActive
                ? "border-black bg-black text-white"
                : c.accent === "gold"
                ? "border-[#B8912B] bg-[#FBF6E4] text-[#B8912B] hover:bg-[#B8912B] hover:text-white"
                : "border-gray-200 bg-white text-black hover:border-black"
            )
          }
        >
          {c.label}
        </NavLink>
      ))}
    </div>
  );
};

export default CategoryChips;
